/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.hero", {
        options: {},

        _create: function () {
            this.wrap = this.element;
            this.wrap.addClass("ready")
            this.carousel = $(".s-hero__conts", this.wrap);

            this.items = $(".s-hero__item", this.wrap);

            this._arrowDown()

            this._loadAllImgs()

            if (this.items.length > 1) {

                this._createArrowPlaceholder();

                this.carousel.on('init', (event, slick)=>{
                    api.accessibilities.aria_slick_arrows(this.wrap)
                    
                });

                //console.log(this.wrap, api.fn.getData(this.wrap, 'autoplay-speed', 10000))

                this.carousel.slick({
                    rows: 0,
                    infinite: true,
                    dots: false,
                    arrows: true,
                    prevArrow: api.vars.slick.prevArrow,
                    nextArrow: api.vars.slick.nextArrow,
                    edgeFriction: api.vars.slick.edgeFriction,
                    autoplay: api.fn.getData(this.wrap, 'autoplay', false),
                    autoplaySpeed: api.fn.getData(this.wrap, 'autoplay-speed', 10000),
                    pauseOnHover: false,
                    appendArrows: this.arrowHolder.find('.s-hero__arrows__ins')
                });

                // this.carousel.on('beforeChange', (slick, currentSlide, nextSlide)=>{
                //     this.carousel.find('[data-src]').lazy();
                // });
    
                // this.carousel.on('afterChange', (slick, currentSlide)=>{
                //     this.carousel.find('[data-src]').lazy();
                // })
            }
        },

        _loadAllImgs(){

            this.wrap.find('.s-hero__item').each( (indx, item) =>{
                if($(item).attr('data-src') && $(item).attr('data-src') !==""){
                    $(item).css('background-image', `url(${$(item).attr('data-src')}`)
                }

                // var rightBg = $('.s-hero__img-right__bg', $(item))
                // if(rightBg.length){
                //     if(rightBg.attr('data-src') && rightBg.attr('data-src') !==""){
                //         rightBg.css('background-image', `url(${rightBg.attr('data-src')}`)
                //     }
                // }
            })

        },

        _createArrowPlaceholder(){
            this.arrowHolder = $('<div class="s-hero__arrows"><div class="s-hero__arrows__ins"></div></div>').appendTo(this.wrap)
        },

        _arrowDown(){
            $('.e-arrow--down', this.wrap).on('click', ()=>{
                api.fn.moveWindowToObj(this.wrap.next());
            })
        }

    });
})(jQuery);
